
<div class="sub-header" 
    *ngIf="dataSub && isDesktop" 
    style="cursor: url('assets/images/icon/computer-mouse2.png') 4 14, auto;">
    <ngx-slick-carousel
        class="carousel" 
        #slickModalSubHead="slick-carousel" 
        [config]="slideSubHeaderConfig">
        <div ngxSlickItem 
            *ngFor="let item of dataSub.children; let key = index" 
            class="slide">
            <div [routerLink]="'/'+dataSub.link+'/'+item.link" 
                class="menu-bar d-block"
                routerLinkActive="current"
                (click)="slickModalSubHead.slickGoTo(key)"
                id="{{ key }}">
                <div class="bar-color">
                </div>
                {{ item.title }}
            </div>
        </div>
    </ngx-slick-carousel>
</div>

